import { Outlet } from 'react-router-dom'
import { Grid } from '@mui/material'
import { TopBar } from './TopBar'
import { Offline, Online } from 'react-detect-offline'
import { NoConnection } from '@innovatrics/checkin-components'

export const MainLayout = () => {
  return (
    <Grid container flexDirection={'row'}>
      <Grid item>
        <TopBar />
      </Grid>
      <Grid item marginX={'auto'} marginTop={'110px'} width={'100%'}>
        {/* <Online> */}
        <Outlet />
        {/* </Online>
        <Offline>
          <NoConnection />
        </Offline> */}
      </Grid>
    </Grid>
  )
}
